<template>
  <div class="upload-files">
    <el-upload
      v-if="!isDetail"
      ref="upload"
      action=""
      :show-file-list="false"
      class="avatar-uploader"
      :http-request="handleChange"
      :before-upload="beforeAvatarUpload"
      :limit="limit"
    >
      <div class="upload-btn" v-loading="loading">
        <i class="el-icon-plus"></i>
        <span>上传文件</span>
      </div>
    </el-upload>

    <div
      class="file-list1"
      v-for="(item, index) in fileList"
      :key="index"
      v-if="isDetail"
    >
      <div class="file-list-title">
        {{ item.filename }}
      </div>
      <span class="icon-delete" @click="down(index, item)"
        ><i class="el-icon-download"></i
      ></span>
    </div>
    <div
      class="file-list"
      v-for="(item, index) in fileList"
      :key="index"
      v-if="!isDetail"
    >
      <div class="file-list-title">
        {{ item.filename }}
      </div>
      <span class="icon-delete" @click="del(index, item)" v-if="!isDetail"
        ><i class="el-icon-delete"></i
      ></span>
    </div>
  </div>
</template>

<script>
import { uploadFile } from "@/views/commonApi";

export default {
  name: "UploadFiles2",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: [],
      default: () => {
        return [];
      },
    },

    limit: {
      type: Number,
      default: 1000,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    maxSize: {
      type: Number,
      default: 20,
    },
    fileType: {
      type: Array,
      default: () => {
        return ["pdf", "png", "jpeg", "jpg", "docx", "doc", "xlsx", "xls"];
      },
    },
  },
  data() {
    return {
      imageUrl: "",
      loading: false,
    };
  },
  computed: {
    fileList: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("change", val);
      },
    },
  },
  methods: {
    down() {},
    del(index, item) {
      if (item.id) {
        this.$emit("deleteItem", index, item);
      } else {
        this.fileList.splice(index, 1);
      }
    },
    // 图片上传之前的
    beforeAvatarUpload(file) {
      if (this.limit === this.fileList.length) {
        this.$message.error(`只能上传${this.limit}个文件`);
        return false;
      }
      // console.log("file.type", file);
      let type = file.name.split(".")[1];
      // console.log("type", type);
      let isPass = this.fileType.includes(type);
      // console.log("isPass", isPass);
      const max = file.size / 1024 / 1024 < Number(this.maxSize);
      if (!isPass) {
        this.$message.error(`只能上传 ${this.fileType.join(",")}格式!`);
      }

      return isPass;
    },
    handleChange(file, fileList) {
      this.uploadFiles(file);
    },
    uploadFiles(file) {
      let that = this;
      // console.log("file", file);
      let files = file.file;
      let formData = new FormData();
      formData.append("file", files);
      that.loading = true;
      uploadFile(formData)
        .then((res) => {
          that.loading = false;
          if (res.code === 200) {
            that.fileList.push(res.data);
            that.$emit("change", that.fileList);
            that.$refs.upload.clearFiles();
          }
        })
        .catch((err) => {
          that.loading = false;
          // console.log(err);
        });
    },
    // getShortImageToken(fileId) {
    //   getShortToken().then((res) => {
    //     if (res.code === 200) {
    //       this.imageUrl =
    //         process.env.VUE_APP_BASE_PATH +
    //         "/file/sys-file/download/public?fileId=" +
    //         fileId +
    //         "&credit=" +
    //         res.data;
    //     }
    //     // console.log("res", this.imageUrl);
    //   });
    // },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.upload-files {
  .el-icon-plus {
    font-size: 0.16rem;
    color: #000000;
  }
  .upload-btn {
    width: 1rem;
    height: 0.3rem;
    background: #ffffff;
    border-radius: 0.04rem;
    border: 0.01rem solid #707070;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      border-color: #516ae9;
      color: #516ae9;
    }
  }
  .file-list {
    display: flex;
    align-items: center;
    width: 100%;
    padding-top: 0.06rem;
    .file-list-title {
      font-size: 0.16rem;
      color: #516ae9;
      &:hover {
        text-decoration: underline;
      }
    }
    .icon-delete {
      display: flex;
      align-items: center;
    }
    .el-icon-delete {
      color: rgba(255, 0, 0, 0.86);
      font-size: 0.2rem;
      margin-left: 0.1rem;
      &:hover {
        color: red;
        cursor: pointer;
      }
    }
    .el-icon-download {
      color: rgba(7, 185, 225, 0.86);
      font-size: 0.2rem;
      margin-left: 0.1rem;
      &:hover {
        color: rgba(7, 185, 225, 0.86);
        cursor: pointer;
      }
    }
  }
  .file-list1 {
    display: flex;
    align-items: center;
    width: 100%;
    padding-bottom: 0.06rem;
    .file-list-title {
      font-size: 0.16rem;
      color: #516ae9;
      &:hover {
        text-decoration: underline;
      }
    }
    .icon-delete {
      display: flex;
      align-items: center;
    }
    .el-icon-delete {
      color: rgba(255, 0, 0, 0.86);
      font-size: 0.2rem;
      margin-left: 0.1rem;
      &:hover {
        color: red;
        cursor: pointer;
      }
    }
    .el-icon-download {
      color: rgba(7, 185, 225, 0.86);
      font-size: 0.2rem;
      margin-left: 0.1rem;
      &:hover {
        color: rgba(7, 185, 225, 0.86);
        cursor: pointer;
      }
    }
  }
}
</style>
